/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=2ec6a12e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2ec6a12e&lang=less&scoped=true"

import exportComponent from "D:\\源码\\frontend\\vue-wms-mobile-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec6a12e"]])

export default __exports__